import { useState, useEffect, useCallback } from 'react';
import api from '../../lib/api';
import { toast } from 'sonner';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Loader2 } from 'lucide-react';
import { statusLabel, levelLabel, levelBadgeClass, fmtDate } from './conductUtils';

export default function TeamCardsTab() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/conduct/team-cards');
      setCards(res.data);
    } catch (e) { toast.error('Failed to load team cards'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="flex justify-center py-12" data-testid="team-cards-loading"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="space-y-2" data-testid="team-cards-tab">
      {cards.length === 0 && <p className="text-sm text-muted-foreground" data-testid="team-cards-empty">No active conduct cards in your team.</p>}
      {cards.map((card) => (
        <Card key={card.id} data-testid={`team-card-${card.id}`}>
          <CardContent className="pt-4 flex items-center justify-between">
            <span className="text-sm font-medium">{card.employee_name}</span>
            <div className="flex items-center gap-2">
              <Badge className={levelBadgeClass(card.level)}>{levelLabel(card.level)}</Badge>
              <Badge variant="outline">{statusLabel(card.status, card, 'hr')}</Badge>
              <span className="text-xs text-muted-foreground">Clears {fmtDate(card.clears_on)}</span>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
